import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const SearchBar = ({ onSearch, onExport, totalResults }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);

  const handleSearch = (e) => {
    e?.preventDefault();
    onSearch(searchQuery);
  };

  return (
    <div className="bg-card border-b border-border">
      <div className="p-4">
        <form onSubmit={handleSearch} className="flex gap-3">
          <div className="flex-1">
            <Input
              type="search"
              placeholder="Audit-Einträge durchsuchen (Beschreibung, Benutzer, Datensatz-ID...)"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
            />
          </div>
          <Button
            type="submit"
            variant="default"
            iconName="Search"
            iconPosition="left"
          >
            Suchen
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => setIsAdvancedOpen(!isAdvancedOpen)}
            iconName={isAdvancedOpen ? 'ChevronUp' : 'ChevronDown'}
            iconPosition="right"
          >
            Erweitert
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onExport}
            iconName="Download"
            iconPosition="left"
          >
            Exportieren
          </Button>
        </form>

        {isAdvancedOpen && (
          <div className="mt-4 p-4 bg-muted/30 rounded-lg space-y-3">
            <h3 className="text-sm font-semibold text-foreground flex items-center gap-2">
              <Icon name="Settings" size={16} />
              Erweiterte Suchoptionen
            </h3>
            <div className="grid grid-cols-3 gap-3">
              <Input
                type="text"
                placeholder="Benutzer-ID"
                label="Benutzer-ID"
              />
              <Input
                type="text"
                placeholder="Datensatz-ID"
                label="Datensatz-ID"
              />
              <Input
                type="text"
                placeholder="IP-Adresse"
                label="IP-Adresse"
              />
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Icon name="Info" size={14} />
              Verwenden Sie erweiterte Filter im linken Bereich für detailliertere Suchen
            </div>
          </div>
        )}
      </div>
      {totalResults > 0 && (
        <div className="px-4 pb-3 flex items-center justify-between text-sm">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Icon name="FileSearch" size={16} />
            {totalResults?.toLocaleString('de-DE')} Ergebnisse gefunden
          </div>
          <div className="flex items-center gap-2">
            <Button variant="ghost" size="sm" iconName="RefreshCw" iconSize={14}>
              Aktualisieren
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;